import { initReactI18next } from 'react-i18next'
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import enTranslation from './en.json'
import trTranslation from './tr.json'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslation,
      },
      tr: {
        translation: trTranslation,
      },
    },
    lng: 'tr',
    fallbackLng: 'tr',
    debug: true,
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
